/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/partners/${encodeURIComponent(request.path['partnerCode'] as any)}/sso`,
    // @ts-ignore for sm-axios
    urlTemplate: '/partners/{partnerCode}/sso',
    method: 'POST',
    data: request.body,
  })
}

/**
 * authenticates a 3rd party user's token
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  path: {
    partnerCode: string
  }
  body: {
    /**
     * 3rd party token containing user email encrypted with partner specific secret
     */
    token: string
    [k: string]: any
  }
}

export interface Response {
  /**
   * This token signed by auth-api, it is a temporary jwt that can be used in auth-api's /user-identity request body. The jwt payload will contain email and partnerCode attributes
   */
  token: string
  /**
   * This is provided to allow the possibility of building an /authenticate request which mandates tenantCode.
   */
  tenantCode: string
  [k: string]: any
}

